module.exports = __webpack_public_path__ + "img/plan.9d848a79.svg";